import "./style.css";
import layout from "./layout.html";
import { getScroll, getInstance, getObserver } from "@app";
import chapters from "@data/chapters.json";

export default class Header {
  static selector = ".header";

  constructor(block) {
    this.block = block;

    this.block.innerHTML = layout;

    this.barTemplate = this.block.querySelector("#header__bars__bar");
    this.barsNode = this.block.querySelector(".header__bars");
    this.barNodes = [];

    this.isFirstScroll = true;

    this.x = window.scrollX;

    this.chapters = Object.values(chapters);

    this.setup();
  }

  setupBarItem = (chapter) => {
    const itemNode = this.barTemplate.content.firstElementChild.cloneNode(true);
    if (itemNode) {
      itemNode.dataset.chapterId = `${chapter.cover.title.number}`;

      const anchorNode = itemNode.querySelector(".header__bars__bar__content");
      anchorNode.href = `#chapter-${chapter.cover.title.number}`;

      const imageNode = itemNode.querySelector(
        ".header__bars__bar__content__image"
      );
      imageNode.style.background = `linear-gradient(0deg, #D3DCDE, #D3DCDE), linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${chapter.cover.image.src}) no-repeat center`;
      imageNode.style.backgroundSize = `cover`;

      const numberNode = itemNode.querySelector(
        ".header__bars__bar__content__number"
      );
      numberNode.textContent = `0${chapter.cover.title.number}`;

      return itemNode;
    } else {
      return false;
    }
  };

  setup = async () => {
    document.documentElement.style.setProperty(
      "--bar-items-number",
      this.chapters.length
    );

    this.chapters.map(async (chapter) => {
      const barItem = this.setupBarItem(chapter);
      if (barItem) {
        this.barsNode.appendChild(barItem);
        this.barNodes.push(barItem);
      }
    });
  };

  updateHeaderHeight = () => {
    document.documentElement.style.setProperty(
      "--header-height",
      this.block.offsetHeight + "px"
    );
  };

  getHeaderColorNodes = () => {
    this.headerColorNodes = document.querySelectorAll("[data-header-color]");
  };

  updateHeaderColorNodesBounds = () => {
    if (!this.headerColorNodes) {
      return;
    }

    this.offsetX = this.x;

    this.headerColorNodes.forEach((item) => {
      item.bounds = item.getBoundingClientRect();
    });
  };

  headerColorNodeIntersectsHeader = (x, node) => {
    return (
      this.bounds.width >= node.bounds.left - x &&
      this.bounds.width <= node.bounds.right - x
    );
  };

  updateBounds = () => {
    this.bounds = this.block.getBoundingClientRect();
  };

  updateColor = (color) => {
    this.block.classList.add(`header--${color}`);
    this.block.classList.remove(`header--${this.color}`);
    this.color = color;
  };

  resetColor = () => {
    this.block.classList.remove(`header--${this.color}`);
    this.color = null;
  };

  chapterChanged = (params) => {
    const { chapterID } = params;
    this.barNodes.forEach((barNode) => {
      barNode.classList.toggle(
        "header__bars__bar--current",
        chapterID === barNode.dataset.chapterId
      );
    });
  };

  onTriggerInView = (entry) => {
    const { target } = entry;
    const parent = target.closest("[data-header-in-view-id]");
    const chapterID = parent.dataset.headerInViewId;
    this.barNodes.forEach((barNode) => {
      barNode.classList.toggle(
        "header__bars__bar--current",
        chapterID === barNode.dataset.chapterId
      );
    });
  };

  onScroll = (event) => {
    const { x } = event;
    this.x = x;

    if (this.isFirstScroll) {
      this.isFirstScroll = false;

      this.updateHeaderColorNodesBounds();
    }

    this.headerColorNodes.forEach((node) => {
      if (this.headerColorNodeIntersectsHeader(x - this.offsetX, node)) {
        if (node.dataset.headerColor !== this.color) {
          node.isIntersectingHeader = true;
          this.updateColor(node.dataset.headerColor);
        }
      } else {
        if (node.isIntersectingHeader) {
          node.isIntersectingHeader = false;
          this.resetColor();
        }
      }
    });

    /*if (
      [...this.headerColorNodes].filter((node) => node.isIntersectingHeader)
        .length === 0
    ) {
      this.resetColor();
    }*/
  };

  onReady = () => {
    return new Promise(async (resolve, reject) => {
      this.mounted = true;

      this.updateBounds();

      this.onResize();

      resolve();
    });
  };

  onComplete = () => {
    this.getHeaderColorNodes();
    this.updateHeaderColorNodesBounds();

    this.scroll = getScroll();
    this.scroll.registerOnScrollPositionChange(this.onScroll);

    this.observer = getObserver();

    this.headerInViewTriggerNodes = document.querySelectorAll(
      ".header-in-view-trigger"
    );
    this.headerInViewTriggerNodes.forEach((node, index) => {
      node.dataset.observerId = `trigger-${index}`;
      this.observer.register(
        node.dataset.observerId,
        this.onTriggerInView,
        node
      );
    });
  };

  onResize = () => {
    this.offsetX = this.x;
    this.updateBounds();
    this.updateHeaderHeight();
    this.updateHeaderColorNodesBounds();
  };
}
